import React, { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const GetEpms = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const API_URL = process.env.REACT_APP_API_URL_V;
  const token = searchParams.get("token");
  const tokenID = searchParams.get("tokenID");
  console.log(token, "token");
  const navigate = useNavigate();
  const credentials = { username: token, password: "User#@31" };
  useEffect(async (event) => {
    if (token) {
      try {
        const response = await fetch(`${API_URL}/auth/epmslogin`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            token: token,
            "visitor-id": tokenID,
          },
        });
        console.log(response, "response");
        if (!response.ok) {
          const errorData = await response.json();
          navigate("/");
          window.location.reload();
          throw new Error(errorData.error || "Login failed");
        }

        const data = await response.json();
        console.log(data);

        if (data.token) {
          setUserDataInLocalStorage(data);

          navigate("/dashboard");
          window.location.reload();
        } else {
          navigate("/");
          window.location.reload();
        }
      } catch (error) {
        console.error("Login error:", error);
        navigate("/");
        window.location.reload();
      }
    } else {
      navigate("/");
      window.location.reload();
    }
  });

  const setUserDataInLocalStorage = (userData) => {
    const userDataObject = {
      email: credentials.username,
      _id: userData._id,
      firstname: userData.firstname,
      lastname: userData.lastname,
      mobile: userData.mobile,
      dial_code: userData.dial_code,
      username: userData.username,
      role: userData.role,
      status: userData.status,
      theme: userData.theme,
    };
    localStorage.setItem("accesstoken", userData.token);
    localStorage.setItem("refreshtoken", userData.refreshToken);
    localStorage.setItem("userData", JSON.stringify(userDataObject));
  };

  return <div></div>;
};

export default GetEpms;
